import itemsImage from 'web-app/assets/images/items.png?sizes[]=300,sizes[]=600,sizes[]=1024&format=webp&rl';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { Registry, service } from '@ember/service';
import styles from '../login/styles.css';

interface JoinMeetingArgs {
  email: string;
  token: string;
}

export default class JoinMeeting extends Component<JoinMeetingArgs> {
  @service api!: Registry['api'];

  styles = styles;
  images = {
    items: itemsImage,
  };
  @tracked clientAgree = false;
  @tracked clientAgreeDari = false;
  @tracked password = '';
  @tracked passwordRepeat = '';
  @tracked hasSent = false;

  validateForm() {
    const errors = [];
    //if (this.password === '') errors.push('Password is required');
    //if (this.passwordRepeat === '') errors.push('Repeat Password is required');
    //if (this.password.length < 8) errors.push('Password must be at least 8 characters');
    //if (this.password !== this.passwordRepeat) errors.push('Your passwords do not match');
    if (!this.clientAgree && !this.clientAgreeDari) errors.push('You must agree to the terms policy');
    if (errors.length) {
      return { success: false, errors };
    }

    return { success: true };
  }

  get formValid() {
    return this.validateForm();
  }

  @action
  async resetPassword(formData: FormInfo): Promise<FormResult> {
    const validations = this.validateForm();
    if (validations.success) {
      const result = await this.api.updateMeeting({
        appointmentId: this.args.email,
        token: this.args.token,
      });
      if (result.json.text) {
        window.location.href = result.json.text as string;
      }

      return { success: true };
    }

    return { ...validations, message: 'Something is wrong' };
  }
}
